var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"loading-box"},[_c('a-spin',{attrs:{"size":"large","tip":"加载中..."}})],1):(_vm.info)?_c('router-view'):_c('div',{staticClass:"empty-box content"},[_c('a-empty',{attrs:{"image":_vm.simpleImage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }